import React, { useState } from "react";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseModal from "../../components/BaseModal";
import "./style.scss";
import ROUTES from "../../utils/routes";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useAuth from "../../hooks/useAuth";

export default function AlreadyUsedLink() {
  const [error, setError] = useState(null);
  const { navigateTo } = useCustomNavigate();
  const { token } = useAuth();
  return (
    <BaseModal
      onPayload={(e) => setError(e)}
      className="used-link-modal"
      title={error}
      titleStyle="used-link-modal__title"
      eventTypeModal={MODAL_TYPES.ALREADY_USED_LINK}
      contentStyle="adult-alert__actions"
      onClose={() => {
        if (token) {
          navigateTo(ROUTES.PERSONAL_ACCOUNT_PAGE);
        }
      }}
    ></BaseModal>
  );
}
